// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:52
import { FileDescriptor_abstract } from './../abstract/SagaSchema/FileDescriptor_abstract';
export class FileDescriptor extends FileDescriptor_abstract {}
